import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { patientDetailsQueryOptions } from "@/features/patients/queries"

const patientSearchSchema = z.object({
  search: z.coerce.string().optional().catch(""),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().optional().catch(undefined),
  facility: z.coerce.number().optional().catch(undefined),
  primaryClinician: z.coerce.number().optional().catch(undefined),
  isActive: z.coerce.boolean().optional().catch(undefined),
  onlyAssigned: z.coerce.boolean().optional().catch(undefined),
  ordering: z.coerce.string().optional().catch(undefined),
  diagnosis_ids: z.string().optional().catch(undefined),
  is_warning: z.coerce.boolean().optional().catch(undefined),
  has_unread_messages: z.coerce.boolean().optional().catch(undefined),
  is_charted_today: z.coerce.boolean().optional().catch(undefined),
  is_diary_filled_today: z.coerce.boolean().optional().catch(undefined),
  has_sleep_apnea: z.coerce.boolean().optional().catch(undefined),
  has_unacknowledged_health_summaries: z.coerce.boolean().optional().catch(undefined),
  tab: z
    .enum([
      "profile",
      "health-data",
      "insights",
      "diary",
      "baselines",
      "warnings",
      "pathways",
      "oncology",
      "chats",
      "sms",
      "adt-events",
    ])
    .optional()
    .catch(undefined),
})

export const Route = createFileRoute("/_app/manage/patients/$patientId/")({
  validateSearch: (search) => {
    return patientSearchSchema.parse(search)
  },
  loader: ({ context, params }) => {
    return context.queryClient.ensureQueryData(
      patientDetailsQueryOptions({
        params: {
          path: { id: params.patientId },
        },
      })
    )
  },
})
